module.exports = __webpack_public_path__ + "static/media/flag-be.4b5c41b0.webp";